module.exports = __webpack_public_path__ + "img/background.2e65fe2a.svg";